import React from 'react'
import { Container, Card } from 'react-bootstrap';

export default function About() {
  return (
    <>
      <Container>
        <Card className="text-center">
          <Card.Body>
              <div className="loading-animation">
                <div className="preloader"></div>
                <h4>Sobre mí en desarrollo...</h4>
              </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  )
}